import { useEffect } from 'react';
import { UseFormSetValue } from 'react-hook-form';

export const usePopulateFormFields = <T extends Record<string, any>>(
  savedData: T | null | undefined,
  setValue: UseFormSetValue<any>,
) => {
  useEffect(() => {
    if (savedData) {
      Object.keys(savedData)?.forEach((key) => {
        setValue(
          key as string & keyof T,
          savedData[key as keyof T],
        );
      });
    }
  }, [savedData, setValue]);
};
